<template>
  <v-main>
    <Marcas />

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-card class="mx-auto my-1 pa-6" outlined max-width="580">
          <p class="text-center mt-n2 display-1 font-weight-light">Entrar!</p>
          <p style="color: #0066ff" class="mb-8 text-center font-weight-light">
            Informe seu usário para continuar
          </p>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                outlined
                v-model="usuario"
                :rules="[obrigatorio]"
                prepend-inner-icon="account_box"
                label="*Usuário"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                outlined
                v-model="senha"
                type="password"
                :rules="[obrigatorio]"
                prepend-inner-icon="lock"
                label="*Senha"
                required
                @keyup.enter="login"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="text-right">
              <v-btn
                color="success"
                class="mr-4"
                :disabled="!valid"
                @click="login"
                >Entrar</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-form>

    <v-dialog v-model="dialogErro" max-width="310">
      <v-card>
        <v-card-title class="label-f18">Atenção</v-card-title>
        <v-card-text>
          <p v-html="mensagem"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialogErro = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import Marcas from '@/components/Marcas.vue';
export default {
  components: {
    Marcas,
  },
  data() {
    return {
      mensagem: '',
      dialogErro: false,
      images: this.$const.images,
      valid: true,
      usuario: '',
      senha: '',
      obrigatorio: (v) => !!v || 'Preenchimento obrigatório',
      servicoBancoIndicacao: '/auth',
    };
  },
  methods: {
    getHostId() {
      /* eslint-disable */
      return new Promise(function (resolve, reject) {
        if (window.navigator.userAgent.includes('Edge/')) {
          let ipAddresses = [];

          var oRTCIceGatherer = new RTCIceGatherer({
            gatherPolicy: 'all',
            iceServers: [],
          });
          oRTCIceGatherer.onlocalcandidate = function (oEvent) {
            if (oEvent.candidate.type == 'host') {
              ipAddresses.push(oEvent.candidate.ip);
            }
          };

          setTimeout(function () {
            resolve(ipAddresses[0]);
          }, 1000);
        } else if (
          navigator.userAgent.indexOf('MSIE') != -1 ||
          !!document.documentMode == true
        ) {
          try {
            var network = new ActiveXObject('WScript.Network');

            resolve(network.computerName);
          } catch (e) {
            if (e.number == '-2146827859') {
              alert(
                'Para melhor funcionamento desse sistema no IE, por favor autorize o uso de Active X'
              );
            }
            resolve('');
          }
        } else {
          var RTCPeerConnection =
            window.webkitRTCPeerConnection || window.mozRTCPeerConnection;

          if (!RTCPeerConnection) {
            reject('Seu browser nao suporta API RtcConnerction');
          }

          var rtc = new RTCPeerConnection({ iceServers: [] });
          var addrs = {};
          addrs['0.0.0.0'] = false;

          function grepSDP(sdp) {
            var finalIP = '';
            sdp.split('\r\n').forEach(function (line) {
              var parts, addr, type;

              if (~line.indexOf('a=candidate')) {
                parts = line.split(' ');
                addr = parts[4];
                type = parts[7];

                if (type === 'host') {
                  finalIP = addr;
                }
              } else if (~line.indexOf('c=')) {
                parts = line.split(' ');
                addr = parts[2];
                finalIP = addr;
              }
            });
            return finalIP;
          }

          if (1 || window.mozRTCPeerConnection) {
            rtc.createDataChannel('', { reliable: false });
          }

          rtc.onicecandidate = function (evt) {
            if (evt.candidate) {
              var addr = grepSDP('a=' + evt.candidate.candidate);
              resolve(addr);
            }
          };
          rtc.createOffer(
            function (offerDesc) {
              rtc.setLocalDescription(offerDesc);
            },
            function (e) {
              console.warn('offer failed', e);
            }
          );
        }
      });
    },
    login() {
      var _this = this;
      this.mensagem = '';
      this.dialogErro = false;
      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
      this.getHostId()
        .then(function (resultado) {
          _this.$utils.setCookie('XHID', resultado, 1);
          _this.autenticarUsuario();
        })
        .catch((e) => {
          _this.autenticarUsuario();
        });
    },
    autenticarUsuario() {
      let loginRequest = { user: this.usuario, password: this.senha };
      this.$http
        .post(`${this.servicoBancoIndicacao}/token`, loginRequest)
        .then((response) => {
          localStorage.setItem('user_name', response.data.userName);
          localStorage.setItem('cod_consultor', this.usuario);
          this.$router.push('/');
          this.$eventBus.$emit('logged');
        })
        .catch((error) => {
          if (
            error.response &&
            (error.response.status == 401 || error.response.status == 403)
          ) {
            this.mensagem = this.$msg.USUARIO_SENHA_INVALIDOS;
          } else {
            this.mensagem =
              this.$utils.trataErrorHttpResponse(error) ||
              this.$msg.USUARIO_SENHA_INVALIDOS;
          }
          this.dialogErro = true;
        })
        .then(() => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },
  },
};
</script>
